/**
 * Carries the `settingsValues` object that a write applies to the
 * operator's opaque bag.
 *
 * PUT treats the object as the new document. PATCH shallow-merges these
 * keys onto the stored bag (omit to leave, null to erase).
 */
export class UpdateUserAppSettingsDto {
  settingsValues!: Record<string, unknown>;
}
